export function numberToFixedLength(number: number, length: number) {
  const numberAsText = number.toString();
  const numberOfZeroesToAdd = length - numberAsText.length;
  const zeroesToAdd = numberOfZeroesToAdd > 0 ? Array(numberOfZeroesToAdd).fill('0') : '';

  return zeroesToAdd + numberAsText;
}

export function toBase36(num: number): string {
  const base36Chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const base = base36Chars.length;
  let result = '';

  if (num === 0) {
    return base36Chars[0];
  }

  while (num > 0) {
    result = base36Chars[num % base] + result;
    num = Math.floor(num / base);
  }

  return result;
}
